/* ========================================
   ADI Lifecycle Mock Data
   Dati estesi per 7 ruoli utente
   ======================================== */

/* ═══ STATO PRATICA — Mappa ciclo di vita ═══
   Il campo `stato` esistente nei patients mappa così:
   da_accettare     → stato_pratica: "in_triage"
   presa_in_carico  → stato_pratica: "in_valutazione"
   in_valutazione   → stato_pratica: "in_valutazione"
   pai_completato   → stato_pratica: "pai_attivo"
   assegnazione     → stato_pratica: "in_erogazione"
*/
export const STATO_PRATICA = {
  INVIATA: 'inviata',
  IN_TRIAGE: 'in_triage',
  IN_VALUTAZIONE: 'in_valutazione',
  PAI_ATTIVO: 'pai_attivo',
  IN_EROGAZIONE: 'in_erogazione',
  CONCLUSO: 'concluso',
};

export const STATO_PRATICA_LABELS = {
  inviata: 'Inviata dal MMG',
  in_triage: 'In Triage (Segreteria)',
  in_valutazione: 'In Valutazione UVMD',
  pai_attivo: 'PAI Attivo',
  in_erogazione: 'In Erogazione',
  concluso: 'Concluso',
};

export function mapStatoToLifecycle(stato) {
  const map = {
    da_accettare: STATO_PRATICA.IN_TRIAGE,
    presa_in_carico: STATO_PRATICA.IN_VALUTAZIONE,
    in_valutazione: STATO_PRATICA.IN_VALUTAZIONE,
    pai_completato: STATO_PRATICA.PAI_ATTIVO,
    assegnazione: STATO_PRATICA.IN_EROGAZIONE,
  };
  return map[stato] || STATO_PRATICA.INVIATA;
}

/* ═══ DATI MMG — Moduli compilati dal Medico di Medicina Generale ═══ */
export const datiMMG = {
  1: {
    mmgNome: 'Dr. Alessandro Bianchi',
    mmgCodice: 'MMG-RM2-0451',
    modulo431Compilato: true,
    nsisInviato: true,
    dataInvio: '14/01/2026',
    dataCompilazione: '14/01/2026',
    motivoRichiesta: 'Complicanze diabetiche multiple, necessita ADI per monitoraggio e medicazioni',
    complessitaStimata: 'alta',
    urgenza: true,
    allegati: ['Lettera dimissione', 'Esami ematici 10/01/2026', 'ECG'],
  },
  2: {
    mmgNome: 'Dr. Marco Rizzo',
    mmgCodice: 'MMG-RM2-0312',
    modulo431Compilato: true,
    nsisInviato: true,
    dataInvio: '15/01/2026',
    dataCompilazione: '15/01/2026',
    motivoRichiesta: 'Dimissione protetta post-ricovero scompenso cardiaco',
    complessitaStimata: 'alta',
    urgenza: true,
    allegati: ['Lettera dimissione ospedaliera', 'Ecocardiogramma'],
  },
  3: {
    mmgNome: 'Dr.ssa Laura Fabbri',
    mmgCodice: 'MMG-RM2-0287',
    modulo431Compilato: true,
    nsisInviato: true,
    dataInvio: '13/01/2026',
    dataCompilazione: '13/01/2026',
    motivoRichiesta: 'Riabilitazione post-chirurgica femore',
    complessitaStimata: 'media',
    urgenza: false,
    allegati: ['Lettera dimissione chirurgica', 'Rx femore'],
  },
  7: {
    mmgNome: 'Dr.ssa Chiara Morelli',
    mmgCodice: 'MMG-RM1-0198',
    modulo431Compilato: true,
    nsisInviato: true,
    dataInvio: '11/01/2026',
    dataCompilazione: '11/01/2026',
    motivoRichiesta: 'Paziente terminale oncologico, cure palliative domiciliari',
    complessitaStimata: 'alta',
    urgenza: true,
    allegati: ['Relazione oncologo', 'Piano terapeutico oppioidi'],
  },
  8: {
    mmgNome: 'Dr. Fabrizio Galli',
    mmgCodice: 'MMG-RM3-0076',
    modulo431Compilato: true,
    nsisInviato: true,
    dataInvio: '10/01/2026',
    dataCompilazione: '10/01/2026',
    motivoRichiesta: 'Esiti ictus cerebrale, riabilitazione motoria e logopedica',
    complessitaStimata: 'alta',
    urgenza: false,
    allegati: ['TC cranio', 'Valutazione neurologica'],
  },
};

/* ═══ OPERATORI SANITARI ═══ */
export const operatoriSanitari = [
  {
    id: 'op-1',
    nome: 'Infermiere',
    cognome: 'Martina Colombo',
    qualifica: 'Infermiere Professionale',
    codice: 'INF-2045',
    cooperativa: 'Cooperativa Salute Insieme',
    telefono: '+39 340 1112233',
    specializzazioni: ['Medicazioni avanzate', 'Terapia infusionale', 'Diabetologia'],
    attivo: true,
  },
  {
    id: 'op-2',
    nome: 'Fisioterapista',
    cognome: 'Andrea Mancini',
    qualifica: 'Fisioterapista',
    codice: 'FIS-1087',
    cooperativa: 'Consorzio ADI Lazio',
    telefono: '+39 347 4445566',
    specializzazioni: ['Riabilitazione ortopedica', 'Riabilitazione neurologica'],
    attivo: true,
  },
  {
    id: 'op-3',
    nome: 'OSS',
    cognome: 'Giulia Ferretti',
    qualifica: 'Operatore Socio-Sanitario',
    codice: 'OSS-3201',
    cooperativa: 'Cooperativa Assistenza Roma',
    telefono: '+39 351 7778899',
    specializzazioni: ['Igiene personale', 'Mobilizzazione', 'Supporto pasti'],
    attivo: true,
  },
  {
    id: 'op-4',
    nome: 'Logopedista',
    cognome: 'Sara Benedetti',
    qualifica: 'Logopedista',
    codice: 'LOG-0456',
    cooperativa: 'Fondazione Cura Domiciliare',
    telefono: '+39 333 0001122',
    specializzazioni: ['Disfagia', 'Riabilitazione linguaggio post-ictus'],
    attivo: true,
  },
  {
    id: 'op-5',
    nome: 'Infermiere',
    cognome: 'Roberto Bassi',
    qualifica: 'Infermiere Professionale',
    codice: 'INF-2091',
    cooperativa: 'Cooperativa Salute Insieme',
    telefono: '+39 348 3334455',
    specializzazioni: ['Cure palliative', 'Gestione CVC', 'Terapia del dolore'],
    attivo: true,
  },
];

/* ═══ PRESTAZIONI PIANIFICATE (Calendario Operatori) ═══ */
export const prestazioniPianificate = [
  {
    id: 'prest-1',
    pazienteId: 7,
    pazienteNome: 'Elena Ferrara',
    indirizzo: 'Via del Corso 89, 00186 Roma',
    operatoreId: 'op-5',
    tipo: 'Infermieristica',
    descrizione: 'Somministrazione terapia endovenosa + monitoraggio parametri',
    data: '18/02/2026',
    oraInizio: '08:30',
    oraFine: '09:30',
    status: 'programmata',
    qrCode: 'QR-PAZ-007',
    note: 'Paziente oncologico, cure palliative. Attenzione a CVC.',
  },
  {
    id: 'prest-2',
    pazienteId: 7,
    pazienteNome: 'Elena Ferrara',
    indirizzo: 'Via del Corso 89, 00186 Roma',
    operatoreId: 'op-3',
    tipo: 'Assistenza OSS',
    descrizione: 'Igiene personale e mobilizzazione',
    data: '18/02/2026',
    oraInizio: '10:00',
    oraFine: '11:30',
    status: 'programmata',
    qrCode: 'QR-PAZ-007',
    note: '',
  },
  {
    id: 'prest-3',
    pazienteId: 8,
    pazienteNome: 'Marco Ricci',
    indirizzo: 'Piazza Navona 15, 00186 Roma',
    operatoreId: 'op-2',
    tipo: 'Fisioterapia',
    descrizione: 'Riabilitazione motoria arto superiore sx + deambulazione',
    data: '18/02/2026',
    oraInizio: '11:00',
    oraFine: '11:45',
    status: 'programmata',
    qrCode: 'QR-PAZ-008',
    note: 'Esiti ictus. Emilato sx compromesso.',
  },
  {
    id: 'prest-4',
    pazienteId: 8,
    pazienteNome: 'Marco Ricci',
    indirizzo: 'Piazza Navona 15, 00186 Roma',
    operatoreId: 'op-4',
    tipo: 'Logopedia',
    descrizione: 'Riabilitazione linguaggio e deglutizione',
    data: '18/02/2026',
    oraInizio: '14:00',
    oraFine: '14:45',
    status: 'programmata',
    qrCode: 'QR-PAZ-008',
    note: '',
  },
  {
    id: 'prest-5',
    pazienteId: 3,
    pazienteNome: 'Anna Verdi',
    indirizzo: 'Via Tuscolana 320, 00181 Roma',
    operatoreId: 'op-2',
    tipo: 'Fisioterapia',
    descrizione: 'Riabilitazione post-chirurgica femore + rinforzo muscolare',
    data: '18/02/2026',
    oraInizio: '15:00',
    oraFine: '15:45',
    status: 'completata',
    qrCode: 'QR-PAZ-003',
    note: 'Intervento 05/01. Carico parziale consentito.',
    referto: 'Paziente collaborante. ROM ginocchio migliorato a 95°. Proseguo con esercizi di rinforzo quadricipite.',
  },
  {
    id: 'prest-6',
    pazienteId: 1,
    pazienteNome: 'Maria Rossi',
    indirizzo: 'Via Roma 45, 00185 Roma',
    operatoreId: 'op-1',
    tipo: 'Infermieristica',
    descrizione: 'Monitoraggio glicemico + medicazione piede diabetico',
    data: '19/02/2026',
    oraInizio: '09:00',
    oraFine: '10:00',
    status: 'programmata',
    qrCode: 'QR-PAZ-001',
    note: 'Diabete tipo 2, neuropatia. Controllare anche PA.',
  },
  {
    id: 'prest-7',
    pazienteId: 5,
    pazienteNome: 'Teresa Marchetti',
    indirizzo: 'Largo Argentina 7, 00186 Roma',
    operatoreId: 'op-3',
    tipo: 'Assistenza OSS',
    descrizione: 'Igiene personale e preparazione pasti',
    data: '19/02/2026',
    oraInizio: '08:00',
    oraFine: '09:30',
    status: 'programmata',
    qrCode: 'QR-PAZ-005',
    note: '',
  },
];

/* ═══ FEEDBACK PAZIENTI ═══ */
export const feedbackPazienti = {
  7: {
    rating: 4,
    commento: 'Operatori molto gentili e professionali. Puntualita migliorabile.',
    data: '15/02/2026',
    operatoreValutato: 'op-5',
  },
  8: {
    rating: 5,
    commento: 'Eccellente servizio. Il fisioterapista e molto competente.',
    data: '16/02/2026',
    operatoreValutato: 'op-2',
  },
  3: {
    rating: 3,
    commento: 'Servizio adeguato, ma avrei preferito orari piu flessibili.',
    data: '14/02/2026',
    operatoreValutato: 'op-2',
  },
};

/* ═══ COSTI STIMATI PER PRATICA ═══ */
export const costiPratiche = {
  7: { costoMensile: 2850, costoTotale: 8550, durataMesi: 3, tipologia: 'Cure Palliative (CIA-4)' },
  8: { costoMensile: 1920, costoTotale: 5760, durataMesi: 3, tipologia: 'Riabilitazione Post-Ictus (CIA-3)' },
  3: { costoMensile: 1450, costoTotale: 4350, durataMesi: 3, tipologia: 'Riabilitazione Ortopedica (CIA-2)' },
  1: { costoMensile: 980, costoTotale: 2940, durataMesi: 3, tipologia: 'Infermieristica Domiciliare (CIA-1)' },
  5: { costoMensile: 720, costoTotale: 2160, durataMesi: 3, tipologia: 'Assistenza Base (CIA-1)' },
};

/* ═══ PORTALE PAZIENTE — Dati per la vista del paziente ═══ */
export const portalePaziente = {
  7: {
    qrCode: 'QR-PAZ-007',
    prossimaVisita: { data: '18/02/2026', ora: '08:30', tipo: 'Infermieristica', operatore: 'Martina Colombo' },
    visiteProgrammate: [
      { data: '18/02/2026', ora: '08:30', tipo: 'Infermieristica', operatore: 'Martina Colombo' },
      { data: '18/02/2026', ora: '10:00', tipo: 'Assistenza OSS', operatore: 'Giulia Ferretti' },
      { data: '20/02/2026', ora: '08:30', tipo: 'Infermieristica', operatore: 'Martina Colombo' },
    ],
    documenti: ['PAI firmato', 'Consenso informato', 'Scheda terapia'],
  },
  8: {
    qrCode: 'QR-PAZ-008',
    prossimaVisita: { data: '18/02/2026', ora: '11:00', tipo: 'Fisioterapia', operatore: 'Andrea Mancini' },
    visiteProgrammate: [
      { data: '18/02/2026', ora: '11:00', tipo: 'Fisioterapia', operatore: 'Andrea Mancini' },
      { data: '18/02/2026', ora: '14:00', tipo: 'Logopedia', operatore: 'Sara Benedetti' },
      { data: '19/02/2026', ora: '11:00', tipo: 'Fisioterapia', operatore: 'Andrea Mancini' },
    ],
    documenti: ['PAI firmato', 'Consenso informato', 'Piano riabilitativo'],
  },
};

/* ═══ METRICHE ASL (Direzione) ═══ */
export const aslMetrics = {
  riepilogo: {
    paiAttivi: 17,
    paiInScadenza: 4,
    praticheInCorso: 31,
    praticheConcluseAnno: 187,
    operatoriAttivi: 42,
    cooperativeConvenzionate: 5,
  },
  costi: {
    budgetAnnuale: 2400000,
    spesoCorrente: 892000,
    percentualeUtilizzo: 37.2,
    costoMedioPratica: 4770,
    costoMedioMensile: 1590,
  },
  performance: {
    tempoMedioTriage: 1.8,
    tempoMedioValutazione: 4.2,
    tempoMedioAttivazione: 7.5,
    soddisfazionePazienti: 4.2,
    tassoRiospedalizzazione: 8.3,
    tassoAderenzaPAI: 91.7,
  },
  distribuzioneCIA: [
    { livello: 'CIA-1 (Base)', count: 12, percentuale: 25 },
    { livello: 'CIA-2 (Medio)', count: 15, percentuale: 31 },
    { livello: 'CIA-3 (Alto)', count: 14, percentuale: 29 },
    { livello: 'CIA-4 (Molto Alto)', count: 7, percentuale: 15 },
  ],
  andamentoMensile: [
    { mese: 'Set', nuovePratiche: 22, concluse: 18, costo: 145000 },
    { mese: 'Ott', nuovePratiche: 28, concluse: 21, costo: 162000 },
    { mese: 'Nov', nuovePratiche: 25, concluse: 24, costo: 158000 },
    { mese: 'Dic', nuovePratiche: 19, concluse: 26, costo: 141000 },
    { mese: 'Gen', nuovePratiche: 31, concluse: 20, costo: 172000 },
    { mese: 'Feb', nuovePratiche: 17, concluse: 12, costo: 114000 },
  ],
};

/* ═══ RICHIESTE MMG — Pratiche in bozza / inviate dal MMG ═══ */
export const richiesteMMG = [
  {
    id: 'req-draft-1',
    pazienteNome: 'Giovanni Neri',
    pazienteCF: 'NRIGVN50A01H501Z',
    pazienteEta: 76,
    stato: 'bozza',
    dataCreazione: '17/02/2026',
    modulo431: 60,
    nsisCompilato: false,
    diagnosi: 'Insufficienza renale cronica stadio 3',
    urgenza: false,
  },
  {
    id: 'req-draft-2',
    pazienteNome: 'Carla Mantovani',
    pazienteCF: 'MNTCRL38E45H501X',
    pazienteEta: 88,
    stato: 'bozza',
    dataCreazione: '16/02/2026',
    modulo431: 30,
    nsisCompilato: false,
    diagnosi: 'Demenza vascolare con agitazione',
    urgenza: true,
  },
  {
    id: 'req-sent-1',
    pazienteNome: 'Maria Rossi',
    pazienteCF: 'RSSMRA55D42H501B',
    pazienteEta: 71,
    stato: 'inviata',
    dataCreazione: '14/01/2026',
    dataInvio: '14/01/2026',
    modulo431: 100,
    nsisCompilato: true,
    diagnosi: 'Diabete Mellito Tipo 2 con complicanze',
    urgenza: true,
    protocollo: 'PUA-2026-001',
  },
  {
    id: 'req-sent-2',
    pazienteNome: 'Giuseppe Bianchi',
    pazienteCF: 'BNCGPP48A15F205X',
    pazienteEta: 78,
    stato: 'inviata',
    dataCreazione: '15/01/2026',
    dataInvio: '15/01/2026',
    modulo431: 100,
    nsisCompilato: true,
    diagnosi: 'Ipertensione + scompenso cardiaco',
    urgenza: true,
    protocollo: 'PUA-2026-002',
  },
  {
    id: 'req-accepted-1',
    pazienteNome: 'Anna Verdi',
    pazienteCF: 'VRDNNA72L63A944C',
    pazienteEta: 83,
    stato: 'accettata',
    dataCreazione: '13/01/2026',
    dataInvio: '13/01/2026',
    modulo431: 100,
    nsisCompilato: true,
    diagnosi: 'Frattura collo del femore',
    urgenza: false,
    protocollo: 'PUA-2026-003',
    dataAccettazione: '14/01/2026',
  },
];
